import React, { useState } from 'react';
import { Box, Typography, Paper, Modal, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ZoomInIcon from '@mui/icons-material/ZoomIn';

interface DiagramViewerProps {
  title: string;
  imageUrl: string;
  description: string;
}

const DiagramViewer: React.FC<DiagramViewerProps> = ({
  title,
  imageUrl,
  description,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Paper
        variant="outlined"
        sx={{
          p: 2,
          mb: 2,
          cursor: 'pointer',
          '&:hover': { bgcolor: 'action.hover' },
        }}
        onClick={() => setOpen(true)}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={1}
        >
          <Typography variant="subtitle2" fontWeight="bold">
            {title}
          </Typography>
          <ZoomInIcon fontSize="small" color="action" />
        </Box>
        <Box
          sx={{
            height: 100,
            bgcolor: 'action.selected',
            borderRadius: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 1,
            backgroundImage: `url(${imageUrl})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
          {!imageUrl && (
            <Typography variant="caption" color="text.secondary">
              [Diagram Preview]
            </Typography>
          )}
        </Box>
        <Typography variant="caption" display="block">
          {description}
        </Typography>
      </Paper>

      <Modal
        open={open}
        onClose={() => {
          setOpen(false);
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '80%',
            maxWidth: 800,
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
            outline: 'none',
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <Typography variant="h6">{title}</Typography>
            <IconButton onClick={() => setOpen(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box
            sx={{
              height: 400,
              bgcolor: 'action.selected',
              borderRadius: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundImage: `url(${imageUrl})`,
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
            }}
          >
            {!imageUrl && (
              <Typography>[Full Size Diagram Placeholder]</Typography>
            )}
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default DiagramViewer;
